import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuthContext from '../../../hooks/useAuthContext';

const Unauthorized = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname;

    const { isSignedIn } = useAuthContext();

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4">
            <Result
                status="403"
                title="403"
                subTitle="No tienes permisos para acceder a esta sección."
                extra={
                    <div className="flex gap-3 justify-center">
                        {
                            !isSignedIn &&
                            <Button type="primary" onClick={() => navigate('/login', { state: { from } })}>
                                Iniciar sesión
                            </Button>
                        }
                        <Button onClick={() => navigate('/')}>Ir al inicio</Button>
                    </div>
                }
            />
        </div>
    );
};

export default Unauthorized;
